<ion-content>
  <ion-list>
    <!-- <ion-item  button class="settingsval" (click)="changedate()" *ngIf="global.refresh">
      <ion-icon name="calendar" color=primary style=" font-size: 20px" ></ion-icon>&nbsp;&nbsp;Change Date
  
    </ion-item> -->
    <ion-item button  class="settingsval" (click)="refresh()" *ngIf="global.refresh">
      <ion-icon name="reload-outline" color=primary style=" font-size: 20px;" ></ion-icon>&nbsp;&nbsp;Refresh
    </ion-item>
    <ion-item class="settingsval">
      <ion-label >
          <ion-icon name="sync" color=primary style="font-size: 20px"></ion-icon>&nbsp;&nbsp;Offline
  
        </ion-label>
      <ion-toggle [(ngModel)]="global.offline" (ngModelChange)="changeOffline()"></ion-toggle>
    </ion-item>
    <ion-item button class="settingsval" (click)="logout()" *ngIf="!global.offline && !global.isOffline">
      <ion-icon name="enter-outline" color=primary style=" font-size:20px;"></ion-icon>&nbsp;&nbsp;Logout
    </ion-item>
  </ion-list>
</ion-content>
